
import {
  AddWasteContainerMeasurementDto,
  CloseWasteContainerDto,
  DisposeWasteContainerDto,
  WasteContainerLogDto,
  WasteContainerMeasurementDto,
  TransferWasteContainerDto,
  WasteContainerDto,
  CreateWasteContainerDto,
  UpdateWasteContainerDto,
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase, axios } from './api'
import { PaginatedDto } from './extendedType'

export type WasteContainersFilters = PaginatedQueryBase & {
  includeInactive?: boolean
  search?: string
  excludeAssignedToWorkbench?: boolean
  excludeAssignedToWorkbenchExceptId?: string
  status?: string
  type?: string
  activityLevel?: string
  isotopeId?: string
  isotopeIds?: string
  no?: number
}

class WasteContainerService extends BaseCrudService<
  WasteContainerDto,
  CreateWasteContainerDto,
  UpdateWasteContainerDto,
  WasteContainersFilters
> {
  constructor() {
    super('waste-container', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }

  close(id: string, dto: CloseWasteContainerDto): Promise<WasteContainerDto> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig('patch', `${this.endpoint}/${id}/close`, dto)
      axios(configs, resolve, reject)
    })
  }

  dispose(id: string, dto: DisposeWasteContainerDto): Promise<WasteContainerDto> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig('patch', `${this.endpoint}/${id}/dispose`, dto)
      axios(configs, resolve, reject)
    })
  }

  transfer(id: string, dto: TransferWasteContainerDto): Promise<WasteContainerDto> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig('patch', `${this.endpoint}/${id}/transfer`, dto)
      axios(configs, resolve, reject)
    })
  }

  reopen(id: string): Promise<WasteContainerDto> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig('patch', `${this.endpoint}/${id}/reopen`)
      axios(configs, resolve, reject)
    })
  }

  cancelDispose(id: string): Promise<WasteContainerDto> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig('patch', `${this.endpoint}/${id}/cancel-dispose`)
      axios(configs, resolve, reject)
    })
  }

  cancelTransfer(id: string): Promise<WasteContainerDto> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig('patch', `${this.endpoint}/${id}/cancel-transfer`)
      axios(configs, resolve, reject)
    })
  }

  getLogs(id: string, params?: PaginatedQueryBase): Promise<PaginatedDto<WasteContainerLogDto>> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig('get', `${this.endpoint}/${id}/logs`, undefined, params as Record<string, unknown>)
      axios(configs, resolve, reject)
    })
  }

  getMeasurements(id: string, params?: PaginatedQueryBase): Promise<PaginatedDto<WasteContainerMeasurementDto>> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig('get', `${this.endpoint}/${id}/measurements`, undefined, params as Record<string, unknown>)
      axios(configs, resolve, reject)
    })
  }

  addMeasurement(id: string, dto: AddWasteContainerMeasurementDto): Promise<void> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig('post', `${this.endpoint}/${id}/measurements`, dto)
      axios(configs, resolve, reject)
    })
  }
}

export const wasteContainerService = new WasteContainerService()
